import { apiSlice } from "../../../app/apiSlice";

const apiSliceWithTags = apiSlice.enhanceEndpoints({
  addTagTypes: ["Broadsheet"],
});

const classBroadsheetApiSlice = apiSliceWithTags.injectEndpoints({
  endpoints: (builder) => ({
    getBroadsheet: builder.query({
      query: ({ classroom_id, term_id, calculation } = {}) => ({
        url: `/report/broadsheet`,
        params: { classroom_id, term_id, calculation },
      }),
      providesTags: ["Broadsheet"],
    }),
    createBroadsheet: builder.mutation({
      query: (values) => ({
        url: "/report/broadsheet",
        method: "POST",
        body: { ...values },
      }),
      invalidatesTags: ["Broadsheet"],
    }),
    deleteBroadsheet: builder.mutation({
      query: (values) => ({
        url: "/report/broadsheet",
        method: "DELETE",
        body: { ...values },
      }),
      invalidatesTags: ["Broadsheet"],
    }),
    getReportStatus: builder.query({
      query: (taskId) => `/report/status/${taskId}`,
      keepUnusedDataFor: 0,
    }),
    cancelReport: builder.mutation({
      query: (taskId) => ({
        url: `/report/cancel/${taskId}`,
        method: "POST",
      }),
    }),
  }),
});

export const {
  useGetBroadsheetQuery,
  useLazyGetBroadsheetQuery,
  useCreateBroadsheetMutation,
  useDeleteBroadsheetMutation,
  useGetReportStatusQuery,
  useCancelReportMutation,
} = classBroadsheetApiSlice;
